<template>
    <div>
        <div class="bg-warning">
            <div class="container d-none d-lg-flex align-items-center justify-content-between fs-15 fw-light px-2 py-3 min_height__54">
                <router-link :to="{name: 'home-locale', params: {locale: currentLocale}}" class="navbar-brand me-0 text-white fw-bold fs-6 px-2 sub_header__link">
                    Get-Parts
                </router-link>

                <a v-if="requisites.PHONE_1" :href="`tel:+${requisites.PHONE_1}`"
                   class="d-block text-light fw-600 sub_header__link">
                    <i class="fa-solid fa-phone"></i>
                    +{{ formatPhone(requisites.PHONE_1) }}
                </a>

                <a v-if="requisites.PHONE_2" :href="`tel:+${requisites.PHONE_2}`"
                   class="d-block text-light fw-600 sub_header__link">
                    <i class="fa-solid fa-phone"></i>
                    +{{ formatPhone(requisites.PHONE_2) }}
                </a>

                <a v-if="requisites.LOC_GOOGLE_MAP_LINK"
                   :href="requisites.LOC_GOOGLE_MAP_LINK"
                   class="d-block text-light fw-600 sub_header__link"
                   target="_blank">
                    <i class="fa-solid fa-location-dot"></i>
                    {{ requisites.LOC_CITY && locale ? requisites.LOC_CITY[locale] : '' }},
                    {{ requisites.LOC_ADDRESS && locale ? requisites.LOC_ADDRESS[locale] : '' }}
                </a>
            </div>
        </div>

        <div class="bg-white shadow-sm pos_sticky">
            <div class="container px-2">
                <nav class="navbar navbar-expand-lg">
                    <div class="container-fluid px-0">
                        <router-link :to="{name: 'home-locale', params: {locale: currentLocale}}" class="navbar-brand me-0">
                            <img :src="Logo" alt="Logo" width="150">
                        </router-link>

                        <div class="d-flex align-items-center flex-lg-grow-1">
                            <button aria-controls="offcanvasNavbar"
                                    aria-label="Toggle navigation"
                                    class="navbar-toggler border-0 p-0 order-lg-1 order-2"
                                    data-bs-target="#offcanvasNavbar"
                                    data-bs-toggle="offcanvas"
                                    type="button">
                                <span class="navbar-toggler-icon"></span>
                            </button>

                            <div id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel"
                                 class="offcanvas offcanvas-end border-0 header_canvas"
                                 tabindex="-1">
                                <div class="offcanvas-header">
                                    <h5 id="offcanvasNavbarLabel" class="offcanvas-title">GET PARTS</h5>
                                    <button aria-label="Close" class="btn-close btn-close-white"
                                            data-bs-dismiss="offcanvas"
                                            type="button"></button>
                                </div>
                                <div class="offcanvas-body header_canvas_body p-0">
                                    <div class="d-flex flex-column justify-content-between h-100 w-100">
                                        <div class="navbar-nav justify-content-end flex-lg-grow-1 pe-lg-3">
                                            <ul class="navbar-nav mx-lg-auto mb-2 mb-lg-0 text-uppercase">
                                                <li class="nav-item">
                                                    <router-link :to="{name: 'parts', params: {locale: currentLocale}}" class="nav-link px-0 mx-2">
                                                        {{ trans('auto_parts') }}
                                                    </router-link>
                                                </li>

                                                <li class="nav-item">
                                                    <router-link :to="{name: 'sale', params: {locale: currentLocale}}"
                                                                 class="nav-link px-0 mx-2 text-danger">
                                                        {{ trans('sale') }}
                                                    </router-link>
                                                </li>

                                                <li class="nav-item">
                                                    <router-link :to="{name: 'news', params: {locale: currentLocale}}" class="nav-link px-0 mx-2">
                                                        {{ trans('news') }}
                                                    </router-link>
                                                </li>

                                                <li class="nav-item">
                                                    <router-link :to="{name: 'about-us', params: {locale: currentLocale}}" class="nav-link px-0 mx-2">
                                                        {{ trans('about_us') }}
                                                    </router-link>
                                                </li>

                                                <li class="nav-item">

                                                    <router-link :to="{name: 'contacts', params: {locale: currentLocale}}" class="nav-link px-0 mx-2">
                                                        {{ trans('contacts') }}
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="d-block d-lg-none border-top p-3 fs-14"
                                             style="border-top-color: #767676!important;">
                                            <a v-if="requisites.PHONE_1"
                                               :href="`tel:+${requisites.PHONE_1}`"
                                               class="d-block text-light">
                                                <i class="fa-solid fa-phone me-1"></i>
                                                +{{ formatPhone(requisites.PHONE_1) }}
                                            </a>

                                            <a v-if="requisites.PHONE_2"
                                               :href="`tel:+${requisites.PHONE_2}`"
                                               class="d-block text-light mt-3">
                                                <i class="fa-solid fa-phone me-1"></i>
                                                +{{ formatPhone(requisites.PHONE_2) }}
                                            </a>

                                            <a v-if="requisites.LOC_GOOGLE_MAP_LINK"
                                               :href="requisites.LOC_GOOGLE_MAP_LINK"
                                               class="d-block text-light mt-3"
                                               target="_blank">
                                                <i class="fa-solid fa-location-dot me-1"></i>
                                                {{ requisites.LOC_CITY && locale ? requisites.LOC_CITY[locale] : '' }},
                                                {{
                                                    requisites.LOC_ADDRESS && locale ? requisites.LOC_ADDRESS[locale] : ''
                                                }}
                                            </a>
                                        </div>

                                    </div>
                                </div>
                            </div>


                            <div class="d-flex align-items-center gap-3 order-lg-2 order-1 me-2">
                                <div class="dropdown">
                                    <a aria-expanded="false"
                                       class="btn btn-light btn-sm dropdown-toggle" data-bs-toggle="dropdown" href="#"
                                       role="button" style="text-transform: uppercase">
                                        {{ currentLocale }}
                                    </a>

                                    <ul class="dropdown-menu" style="z-index: 1100;">
                                        <li>
                                            <a class="dropdown-item" href="#" @click.prevent="changeLocale('en')">EN</a>
                                        </li>

                                        <li>
                                            <a class="dropdown-item" href="#" @click.prevent="changeLocale('ka')">KA</a>
                                        </li>

                                        <li>
                                            <a class="dropdown-item" href="#" @click.prevent="changeLocale('ru')">RU</a>
                                        </li>
                                    </ul>
                                </div>

                                <div @click="changeIcons" :title="!productSearchInput ? trans('search') : ''">
                                    <button aria-controls="collapseSearch"
                                            aria-expanded="false"
                                            class="btn border-0 header__action"
                                            data-bs-target="#collapseSearch"
                                            data-bs-toggle="collapse"
                                            type="button"
                                            style="width: 40px;">
                                        <i :class="!productSearchInput ? 'fa-solid fa-magnifying-glass': 'fa-solid fa-xmark'"></i>
                                    </button>
                                </div>

                                <router-link :title="trans('favourites')"
                                             :to="{name: 'favourites', params: {locale: currentLocale}}"
                                             class="btn border-0 header__action d-block position-relative">
                                    <i class="fa-solid fa-heart"></i>
                                    <span v-if="favoritesCount"
                                          class="fs-12 position-absolute top-0 end-0">{{ favoritesCount }}</span>
                                </router-link>

                                <router-link :title="trans('cart')"
                                             :to="{name: 'cart', params: {locale: currentLocale}}"
                                             class="btn border-0 header__action d-block position-relative">
                                    <i class="fa-sharp fa-solid fa-cart-shopping"></i>
                                    <span v-if="shoppingCartCount"
                                          class="fs-12 position-absolute top-0 end-0">{{ shoppingCartCount }}</span>
                                </router-link>

                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </div>

        <ProductSearch/>
    </div>
</template>

<script>
import Logo from "@/assets/websites/get-parts/img/logo.png"
import {mapGetters} from "vuex"
import {t} from "@/lang/core/helpers";
import ProductSearch from "@/components/websites/get-parts/parts/ProductSearch.vue";
import CloseSearchIcon from "@/assets/websites/get-parts/img/close-search-icon.png"

export default {
    name: 'HeaderGP',

    components: {
        ProductSearch
    },

    data() {
        return {
            Logo,
            CloseSearchIcon,
            productSearchInput: false
        }
    },

    computed: {
        ...mapGetters(['availableLocales', 'company', 'locale', 'requisites', 'shoppingCart', 'favorites',]),

        currentLocale() {
            return this.locale || window.localStorage.getItem('locale') || 'ka'
        },

        shoppingCartCount() {
            let count = 0

            if (!this.shoppingCart || !this.shoppingCart.length) return count

            this.shoppingCart.forEach(item => {
                count += item.quantity
            })

            return count
        },

        favoritesCount() {
            if (!this.favorites || !this.favorites.length) return 0

            return this.favorites.length
        },
    },

    methods: {
        trans(key) {
            return t(key)
        },

        changeLocale(locale) {
            let oldLocale = window.localStorage.getItem('locale') || 'ka'

            if (oldLocale === locale) return

            let path = this.$route.fullPath.replace('/' + oldLocale, '/' + locale)

            window.localStorage.setItem('locale', locale)
            this.$store.commit('setLocale', locale)

            this.$router.push(path)
        },

        formatPhone(phone) {
            return phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1 $2 $3")
        },

        changeIcons() {
            this.productSearchInput = !this.productSearchInput
        },
    },

    watch: {
        changeIcons() {
            this.changeIcons()
        }
    }
}
</script>

<style lang="scss" scoped>
.min_height__54 {
    min-height: 54.5px;
}

//.navbar-brand img {
//    height: 30px !important;
//}

.sub_header__link,
.header__action {
    transition: .3s;
}

.sub_header__link:hover {
    color: #000 !important;
}

.header__action:hover {
    color: #ffc107 !important;
}

@media screen and (min-width: 992px) {
    //.navbar-brand img {
    //    object-fit: cover;
    //}

    header .nav-link {
        position: relative;
    }

    header .nav-link::after {
        background: none repeat scroll 0 0 #ffc107;
        bottom: 0;
        content: '';
        display: block;
        height: 3px;
        left: 50%;
        position: absolute;
        transition: width 0.3s ease 0s, left 0.3s ease 0s;
        width: 0;
    }

    header .nav-link:hover:after {
        width: 100%;
        left: 0;
    }

    header .nav-link:hover {
        color: #ffc107;
    }
}

@media screen and (max-width: 991px) {
    .navbar-brand img {
        width: 80px !important;
    }

    header {
        position: sticky;
        top: 0;
        z-index: 1300;
    }

    .header_canvas {
        width: 300px !important;
    }

    .header_canvas_body,
    .header_canvas .offcanvas-header {
        background-color: #4e4d4d;
    }

    .header_canvas_body .nav-link,
    .header_canvas .offcanvas-header {
        color: #fff !important;
        padding: 16px !important;
    }

    .header_canvas_body .nav-item {
        border-bottom: 1px solid #767676;
    }

    .header_canvas_body .nav-item:first-child {
        border-top: 1px solid #767676;
    }

    .header_canvas_body .nav-item:hover {
        background-color: #ffff;
    }

    .header_canvas_body .nav-link:hover {
        color: #111 !important;
    }
}
</style>